export default "__VITE_ASSET__f96097ed__"